import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TypedMemo } from '../../common/types';
import { setUserToken } from '../../../redux/slices/appInfo/slice';
import { consumeNativeAuthToken } from '../nativeAuthTokenHandoff';

/**
 * Puts the token the native WebView handed over into Redux. `AppInitialEntry`
 * already persisted it and stripped it from the URL at module load, so the
 * booting store normally carries it; this covers a store that already existed.
 *
 * Renders nothing, and sits above every route so no private-route guard sees a
 * signed-out user first.
 */
const NativeAuthTokenHandoffComponent: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = consumeNativeAuthToken();
    if (token === null) {
      return;
    }
    dispatch(setUserToken({ token }));
  }, [dispatch]);

  return null;
};

export const NativeAuthTokenHandoff = TypedMemo(NativeAuthTokenHandoffComponent);
